import { Condition, ConditionGroup, ConditionGroupOperator, ConditionOperator } from 'scripts/type'

export default function calcIsConditionGroupMatched(conditionGroup: ConditionGroup, value: any) {
  const { operator, conditions } = conditionGroup
  return operator === ConditionGroupOperator.Or
    ? conditions.some((condition) => calcConditionIsMatched(condition, value))
    : conditions.every((condition) => calcConditionIsMatched(condition, value))
}

function calcConditionIsMatched(condition: Condition, value: any) {
  const { operator, secondNode } = condition
  const secondNodeValue = secondNode?.value
  const matchFn = (v: number | string) => secondNodeValue?.includes(v) || secondNodeValue?.includes(`${v}`)
  switch (operator) {
    case ConditionOperator.Lt:
      return value < secondNodeValue
    case ConditionOperator.Lte:
      return value <= secondNodeValue
    case ConditionOperator.Eq:
      return value === secondNodeValue
    case ConditionOperator.Gt:
      return value > secondNodeValue
    case ConditionOperator.Gte:
      return value >= secondNodeValue
    case ConditionOperator.Promoter:
      return value > 8
    case ConditionOperator.Passive:
      return value === 7 || value === 8
    case ConditionOperator.Detractor:
      return value < 7
    case ConditionOperator.Include:
      if (Array.isArray(value?.value)) {
        return value?.value.some(matchFn)
      }
      return matchFn(value)
    default:
      return false
  }
}
